import '../Navbar/Navbar.css'
import Mnavbar from '../Navbar/Mnavbar';
import Dnavbar from '../Navbar/Dnavbar';
import React, { useEffect, useState } from 'react';



  const Navbar = () => {
    const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      // Function to update isMobile state based on screen width
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // Adjust the screen width breakpoint as needed
      };
  
      // Initial check and add event listener for window resize
      handleResize();
      window.addEventListener('resize', handleResize);
  
      // Cleanup the event listener when the component unmounts
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

if(isMobile)
{  
return<Mnavbar/>
}
return<Dnavbar/>
};
export default Navbar;